/**
 * Returns a query string containing params that are present in oldQueryString but absent in newQueryString.
 * Query strings should be provided without the leading "?" character.
 */
export function getRemovedQueryParams(oldQueryString: string, newQueryString: string): string {
  const oldParams = new URLSearchParams(oldQueryString);
  const newParams = new URLSearchParams(newQueryString);
  const removedParams = new URLSearchParams();

  oldParams.forEach((value, key) => {
    if (!newParams.has(key)) {
      removedParams.append(key, value);
    }
  });

  return removedParams.toString();
}
